import React, { useMemo, useState, useEffect } from 'react';
import {
  Button,
  Container,
  Grid,
} from '@mui/material';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';


// Theme Stuff / Configs
import { getMuiTableBodyProps, getTableTheme } from '../../js/table_theme_config'; // Import the helpers

// Pure JS
import config from '../../js/config'
import downloadFile from '../../js/download_file'
import { convertEpochToDateTime } from '../../js/time_helpers';
import { getBearerString } from '../../js/jwt_token';

const DatasetsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);


  const process_data = async (data_list) => {
    if (data_list == undefined) {
      return [];
    }
    return data_list.map((element) => {
      return {
        ...element,
        creation_time: convertEpochToDateTime(element?.creation_time_epoch_ns),
      };
    });
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(config.data_platform_api_url + '/datasets', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getBearerString(),
        }
      });
      const json_list = await response.json();
      const processedData = await process_data(json_list.data);
      setData(processedData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const handleDownloadSelected = async (bucket_name_file_paths) => {
    bucket_name_file_paths.forEach(async (bucket_name_file_path) => {
      await downloadFile(bucket_name_file_path);
    });
  };


  useEffect(() => {
    fetchData();
  }, []);


  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Dataset Name',
        size: 150,
      },
      {
        accessorKey: 'version',
        header: 'version',
        size: 150,
      },
      {
        accessorKey: 'status',
        header: 'Download Status',
        size: 150,
      },
      {
        accessorKey: 'creation_time',
        header: 'Creation Time',
        size: 150,
        Cell: ({ cell }) => {
          const dt = cell.getValue();
          if (!dt || typeof dt !== 'object') return '';
          return (
            <div>
              <div>{dt.date}</div>
              <div>{dt.time}</div>
            </div>
          );
        },
      }
    ],
    [],
  );


  const table = useMaterialReactTable({
    columns,
    data,
    getRowId: (row) => row.dataset_bucket_name_file_path,
    state: { isLoading: loading },
    enableRowSelection: (row) => row.original.status === 'available',
    muiTableBodyProps: getMuiTableBodyProps(false), // Use the common props (Darkmode -> true)
    mrtTheme: getTableTheme(false), // Use the common props (Darkmode -> true)
    renderTopToolbarCustomActions: () => (
      <Grid container justifyContent="flex-start">
        <Button onClick={fetchData}>Refresh</Button>
        {Object.keys(table.getState().rowSelection).length > 0 && (
          <>
            <Button onClick={() => { handleDownloadSelected(Object.keys(table.getState().rowSelection)); }}>Download Dataset</Button>
          </>
        )}
      </Grid>
    )
  });


  return (
    <Container maxWidth={false} disableGutters sx={{ pt: 2, width: '100%' }}>
      <MaterialReactTable table={table} />
    </Container>
  );
};

export default DatasetsTable;
